import styled from '@emotion/styled';
import { StyledPageContainer } from '../styles';
import { Link } from 'react-router-dom';
import { breakpoints } from '../../styles/variables/breakpoints';
import { colors } from '../../styles/variables/colors';
import { VFC } from 'react';

export const StyledFooter = styled.div`
  background-color: ${colors.lightGrey};
  width: 100%;
  padding: 60px 0;
`;

export const StyledFooterNav = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 25px 0;

  @media ${breakpoints.width768} {
    flex-direction: column;
  }
`;

export const StyledFooterLink = styled(Link)`
  color: ${colors.black};
  text-decoration: underline;
  text-transform: uppercase;
  padding: 5px 20px;
  font-size: 14px;
`;

export const StyledFooterContact = styled.div`
  text-align: center;
  font-size: 14px;
`;

export const StyledFooterCopyright = styled.div`
  text-align: center;
  font-size: 14px;
`;

export const Footer: VFC = () => {
  const scrollTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <StyledFooter>
      <StyledPageContainer>
        <StyledFooterContact>
          <strong>Kontaktní email:</strong> hlasovani@info.qsystems.cz
        </StyledFooterContact>
        <StyledFooterNav>
          <StyledFooterLink to="/" onClick={scrollTop}>
            Vyhledávání
          </StyledFooterLink>
          <StyledFooterLink to="/list" onClick={scrollTop}>
            Seznam hlasování
          </StyledFooterLink>
          <StyledFooterLink to="/absence" onClick={scrollTop}>
            Absence a prezence
          </StyledFooterLink>
          <StyledFooterLink to="/about" onClick={scrollTop}>
            O projektu
          </StyledFooterLink>
        </StyledFooterNav>
        <StyledFooterCopyright>
          Copyright © {new Date().getFullYear()}, hlasování.Brno. Vytvořil tým
          Pivníci.
        </StyledFooterCopyright>
      </StyledPageContainer>
    </StyledFooter>
  );
};
